angular.module('bmsApp.ticket')
	.factory('TicketSvc', [
		'CRUDSvc',
		'$modal',
		'$rootScope',
		function (CRUDSvc, $modal, $rootScope) {

			function index(params) {
				return CRUDSvc.get('api/ticket/index', params);
			}

			function read(id) {
				return CRUDSvc.get('api/ticket/read/' + id);
			}

			function save(params) {
				return CRUDSvc.post('api/ticket/save', params);
			}

			function saveNote(params) {
				return CRUDSvc.post('api/ticket/save-note', params);
			}

			function closeTicket(params) {
				return CRUDSvc.post('api/ticket/close-ticket', params);
			}

			function openRaiseTicketDialog() {
				var modalInstance = $modal.open({
					animation: true,
					templateUrl: 'ng/ticket/templates/RaiseTicketModal.html',
					controller: 'RaiseTicketModalCtrl',
					controllerAs: 'RaiseTicket',
					size: 'md',
					scope: $rootScope,
					backdrop: 'static', // disable click-outside closing modal
				});

				return modalInstance.result;
			}

			return {
				index: index,
				closeTicket: closeTicket,
				saveNote: saveNote,
				read: read,
				save: save,
				openRaiseTicketDialog: openRaiseTicketDialog
			}

		}
	]);
